module.exports = __webpack_public_path__ + "ed21c3d4d5af4f08dd69c80a4c447d93.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/SohoGothicPro/SohoGothicProMedium.ttf
// module id = 8043
// module chunks = 0